export * from './slim-nav.reducer';
